import { LetterIcon } from "~/icons/LetterIcon";
import { PhoneIcon } from "~/icons/PhoneIcon";
import { PinIcon } from "~/icons/PinIcon";
import { IMAGE_SIZES, buildImageUrl } from "~/lib/utils";

function WebsiteIcon() {
  return (
    <svg
      className="h-5 w-5 shrink-0"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0076 22.1495C10.6043 22.1495 9.28725 21.8838 8.05659 21.3525C6.82592 20.8211 5.74959 20.0945 4.82759 19.1725C3.90559 18.2505 3.17892 17.1738 2.64759 15.9425C2.11625 14.7111 1.85059 13.3931 1.85059 11.9882C1.85059 10.5836 2.11625 9.26523 2.64759 8.03323C3.17892 6.8014 3.90525 5.72857 4.82659 4.81473C5.74792 3.90073 6.82442 3.17723 8.05609 2.64423C9.28775 2.11107 10.6062 1.84448 12.0113 1.84448C13.4163 1.84448 14.7351 2.1109 15.9676 2.64373C17.1999 3.17657 18.2728 3.89965 19.1863 4.81298C20.1 5.72632 20.8233 6.80032 21.3561 8.03498C21.8891 9.26965 22.1556 10.5891 22.1556 11.9932C22.1556 13.3972 21.889 14.7145 21.3558 15.945C20.8228 17.1756 20.0993 18.2502 19.1853 19.1687C18.2715 20.0871 17.1976 20.8135 15.9636 21.348C14.7296 21.8823 13.4109 22.1495 12.0076 22.1495ZM12.0001 20.4462C14.3053 20.4462 16.2653 19.6559 17.8803 18.0752C19.4953 16.4946 20.3387 14.5751 20.4103 12.3167C20.4103 12.2741 20.4113 12.2381 20.4133 12.209C20.4153 12.18 20.4163 12.1475 20.4163 12.1115C20.2925 12.497 20.0612 12.8166 19.7223 13.0705C19.3837 13.3241 18.9889 13.451 18.5381 13.451H16.5681C16.0033 13.451 15.5198 13.2497 15.1176 12.8472C14.7154 12.4446 14.5143 11.9606 14.5143 11.3952V10.3675H10.4066V8.35198C10.4066 7.78298 10.6079 7.29798 11.0106 6.89698C11.4131 6.49615 11.897 6.29573 12.4623 6.29573H13.4903V5.74573C13.4903 5.45773 13.6058 5.10706 13.8368 4.69373C14.0678 4.28057 14.3309 4.04023 14.6261 3.97273C14.2134 3.84523 13.789 3.74357 13.3528 3.66773C12.9168 3.59173 12.4667 3.55373 12.0023 3.55373C9.66284 3.55373 7.66984 4.37223 6.02334 6.00923C4.377 7.64607 3.55384 9.64298 3.55384 12C3.55384 12.016 3.55484 12.0309 3.55684 12.0447C3.55884 12.0587 3.55984 12.0737 3.55984 12.0897H7.03484C8.16667 12.0897 9.13425 12.4913 9.93759 13.2945C10.7409 14.0978 11.1426 15.0644 11.1426 16.1942V17.2212H8.06484V19.5055C8.65534 19.8046 9.28092 20.0362 9.94159 20.2002C10.6024 20.3642 11.2886 20.4462 12.0001 20.4462Z"
        fill="#060606"
      />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg
      className="h-5 w-5 shrink-0"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10.0611C20 4.50451 15.5229 0 10 0C4.47715 0 0 4.50451 0 10.0611C0 15.0828 3.65684 19.2452 8.4375 20V12.9694H5.89844V10.0611H8.4375V7.84452C8.4375 5.32296 9.9305 3.93012 12.2146 3.93012C13.3088 3.93012 14.4531 4.12663 14.4531 4.12663V6.60261H13.1922C11.95 6.60261 11.5625 7.37822 11.5625 8.1739V10.0611H14.3359L13.8926 12.9694H11.5625V20C16.3432 19.2452 20 15.083 20 10.0611Z"
        fill="#060606"
      />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg
      className="h-5 w-5 shrink-0"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="23" height="24" rx="6" fill="#060606" />
      <path
        d="M14.5293 3.5H11.7877V15.0797C11.7877 16.4594 10.7332 17.5928 9.42092 17.5928C8.10866 17.5928 7.05417 16.4594 7.05417 15.0797C7.05417 13.7246 8.08523 12.6159 9.35064 12.5667V9.65943C6.56208 9.70868 4.3125 12.0986 4.3125 15.0797C4.3125 18.0855 6.60894 20.5 9.44437 20.5C12.2797 20.5 14.5762 18.0609 14.5762 15.0797V9.14202C15.6073 9.93044 16.8726 10.3986 18.2083 10.4232V7.51594C16.1462 7.44203 14.5293 5.66811 14.5293 3.5Z"
        fill="white"
      />
    </svg>
  );
}

function SocialProfileIcon({ label }: { label: string }) {
  const l = label.toLowerCase();
  if (l === "facebook") return <FacebookIcon />;
  if (l === "tiktok") return <TikTokIcon />;
  return <WebsiteIcon />;
}

type ContactCardProps = {
  imageUrl?: string;
  name: string;
  email?: string;
  phone?: string;
  company?: string;
  address: string[];
  /** Website URL */
  website?: string | null;
  /** Websites (label + URL) */
  websites?: unknown;
  /** Instagram profile URL */
  socialInstagram?: string | null;
  /** LinkedIn profile URL */
  socialLinkedin?: string | null;
  /** Social profiles (label + URL) */
  socialProfiles?: unknown;
  onImpressumClick?: () => void;
  /** When false, only company, address and Impressum are shown (contact person hidden). Default true. */
  showContactPerson?: boolean;
  /** When false, contact person name/email/phone are shown but without profile image. Default true when showContactPerson is true. */
  showContactPersonImage?: boolean;
  /** When true, website/Instagram/LinkedIn links are shown (e.g. for premium/superior plans). Default false. */
  showLinks?: boolean;
};

function ensureHref(url: string): string {
  const s = url.trim();
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  return `https://${s}`;
}

export function LocationContact({
  imageUrl,
  name,
  email,
  phone,
  company,
  address,
  website,
  websites,
  socialInstagram,
  socialLinkedin,
  socialProfiles,
  onImpressumClick,
  showContactPerson = true,
  showContactPersonImage = true,
  showLinks = false,
}: ContactCardProps) {
  const websitesArray: { label: string; url: string }[] = (() => {
    if (Array.isArray(websites)) return websites;
    if (typeof websites === "string" && websites.trim()) {
      try {
        const parsed = JSON.parse(websites);
        if (Array.isArray(parsed)) return parsed as any;
      } catch {
        return [];
      }
    }
    if (websites && typeof websites === "object") {
      // Handle cases where JSON was deserialized into an object with numeric keys
      return Object.values(websites as any);
    }
    return [];
  })();

  const resolvedWebsites =
    websitesArray
      ?.filter((w) => w && typeof w.url === "string" && w.url.trim())
      ?.map((w) => ({
        label: (w?.label ?? "").toString().trim(),
        url: w.url.toString().trim(),
      })) ?? [];
  const primaryWebsite =
    resolvedWebsites[0]?.url?.trim() || website?.trim() || "";
  const socialProfilesArray: { label: string; url: string }[] = (() => {
    if (Array.isArray(socialProfiles)) return socialProfiles as any;
    if (typeof socialProfiles === "string" && socialProfiles.trim()) {
      try {
        const parsed = JSON.parse(socialProfiles);
        if (Array.isArray(parsed)) return parsed as any;
      } catch {
        return [];
      }
    }
    if (socialProfiles && typeof socialProfiles === "object") {
      return Object.values(socialProfiles as any);
    }
    return [];
  })();
  const resolvedSocialProfiles =
    socialProfilesArray
      ?.filter((p) => p && typeof p.url === "string" && p.url.trim())
      ?.map((p) => ({
        label: (p?.label ?? "").toString().trim(),
        url: p.url.toString().trim(),
      }))
      .filter((p) => p.label || p.url) ?? [];
  const hasLinks =
    (primaryWebsite && true) ||
    (resolvedSocialProfiles.length > 0 && true) ||
    (socialInstagram?.trim() && true) ||
    (socialLinkedin?.trim() && true);
  return (
    <div className="flex justify-start p-6">
      {/* header */}
      <div className="flex flex-col gap-6">
        {showContactPerson && (
          <>
            <div className="flex gap-4">
              {showContactPersonImage && imageUrl && (
                <img
                  src={buildImageUrl(imageUrl, { size: IMAGE_SIZES.avatar })}
                  alt={name}
                  className="h-[100px] w-[100px] rounded-md object-cover"
                />
              )}
              <div>
                <p className="text-sm font-normal">Ansprechpartner</p>
                <p className="font-semibold">{name}</p>
              </div>
            </div>

            {/* mail */}
            {email ? (
              <div className="flex items-start gap-3">
                <span className="mt-1">
                  <LetterIcon />
                </span>
                <div>
                  <p className="font-semibold">E-Mail</p>
                  <a href={`mailto:${email}`} className="underline">
                    {email}
                  </a>
                </div>
              </div>
            ) : null}

            {/* phone */}
            {phone ? (
              <div className="flex items-start gap-3">
                <span className="mt-1">
                  <PhoneIcon />
                </span>
                <div>
                  <p className="font-semibold">Telefon</p>
                  <a className="underline" href={`tel:${phone}`}>
                    {phone}
                  </a>
                </div>
              </div>
            ) : null}
          </>
        )}

        {showLinks && hasLinks ? (
          <div className="flex items-start gap-3 mb-3">
            <div className="flex flex-col flex-wrap gap-3">
              {resolvedWebsites.length > 0 ? (
                resolvedWebsites.map((w, idx) => (
                  <a
                    key={`${w.url}-${idx}`}
                    href={ensureHref(w.url)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex gap-3 items-center font-semibold"
                  >
                    <WebsiteIcon />
                    {w.label ? w.label : "Website"}
                  </a>
                ))
              ) : primaryWebsite ? (
                <a
                  href={ensureHref(primaryWebsite)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex gap-3 items-center font-semibold"
                >
                  <WebsiteIcon />
                  Website
                </a>
              ) : null}
              {socialInstagram?.trim() ? (
                <a
                  href={ensureHref(socialInstagram)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex gap-3 items-center font-semibold"
                >
                  <svg
                    className="h-5 w-5 shrink-0"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16 3.24268H8C5.23858 3.24268 3 5.48126 3 8.24268V16.2427C3 19.0041 5.23858 21.2427 8 21.2427H16C18.7614 21.2427 21 19.0041 21 16.2427V8.24268C21 5.48126 18.7614 3.24268 16 3.24268ZM19.25 16.2427C19.2445 18.0353 17.7926 19.4872 16 19.4927H8C6.20735 19.4872 4.75549 18.0353 4.75 16.2427V8.24268C4.75549 6.45003 6.20735 4.99817 8 4.99268H16C17.7926 4.99817 19.2445 6.45003 19.25 8.24268V16.2427ZM16.75 8.49268C17.3023 8.49268 17.75 8.04496 17.75 7.49268C17.75 6.9404 17.3023 6.49268 16.75 6.49268C16.1977 6.49268 15.75 6.9404 15.75 7.49268C15.75 8.04496 16.1977 8.49268 16.75 8.49268ZM12 7.74268C9.51472 7.74268 7.5 9.7574 7.5 12.2427C7.5 14.728 9.51472 16.7427 12 16.7427C14.4853 16.7427 16.5 14.728 16.5 12.2427C16.5027 11.0484 16.0294 9.90225 15.1849 9.05776C14.3404 8.21327 13.1943 7.74002 12 7.74268ZM9.25 12.2427C9.25 13.7615 10.4812 14.9927 12 14.9927C13.5188 14.9927 14.75 13.7615 14.75 12.2427C14.75 10.7239 13.5188 9.49268 12 9.49268C10.4812 9.49268 9.25 10.7239 9.25 12.2427Z"
                      fill="#060606"
                    />
                  </svg>
                  Instagram
                </a>
              ) : null}
              {socialLinkedin?.trim() ? (
                <a
                  href={ensureHref(socialLinkedin)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex gap-3 items-center font-semibold"
                >
                  <svg
                    className="h-5 w-5 shrink-0"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.5 0C0.67157 0 0 0.67157 0 1.5V16.5C0 17.3284 0.67157 18 1.5 18H16.5C17.3284 18 18 17.3284 18 16.5V1.5C18 0.67157 17.3284 0 16.5 0H1.5ZM5.52076 4.00272C5.52639 4.95897 4.81061 5.54819 3.96123 5.54397C3.16107 5.53975 2.46357 4.90272 2.46779 4.00413C2.47201 3.15897 3.13998 2.47975 4.00764 2.49944C4.88795 2.51913 5.52639 3.1646 5.52076 4.00272ZM9.2797 6.76176H6.75971H6.7583V15.3216H9.4217V15.1219C9.4217 14.742 9.4214 14.362 9.4211 13.9819C9.4203 12.9681 9.4194 11.9532 9.4246 10.9397C9.426 10.6936 9.4372 10.4377 9.5005 10.2028C9.7381 9.3253 10.5271 8.7586 11.4074 8.8979C11.9727 8.9864 12.3467 9.3141 12.5042 9.8471C12.6013 10.1803 12.6449 10.5389 12.6491 10.8863C12.6605 11.9339 12.6589 12.9815 12.6573 14.0292C12.6567 14.399 12.6561 14.769 12.6561 15.1388V15.3202H15.328V15.1149C15.328 14.6629 15.3278 14.211 15.3275 13.7591C15.327 12.6296 15.3264 11.5001 15.3294 10.3702C15.3308 9.8597 15.276 9.3563 15.1508 8.8627C14.9638 8.1286 14.5771 7.5211 13.9485 7.0824C13.5027 6.77019 13.0133 6.5691 12.4663 6.5466C12.404 6.54401 12.3412 6.54062 12.2781 6.53721C11.9984 6.52209 11.7141 6.50673 11.4467 6.56066C10.6817 6.71394 10.0096 7.0641 9.5019 7.6814C9.4429 7.7522 9.3852 7.8241 9.2991 7.9314L9.2797 7.9557V6.76176ZM2.68164 15.3244H5.33242V6.76733H2.68164V15.3244Z"
                      fill="#060606"
                    />
                  </svg>
                  LinkedIn
                </a>
              ) : null}
              {resolvedSocialProfiles.length > 0
                ? resolvedSocialProfiles
                    .filter((p) => {
                      const l = p.label.toLowerCase();
                      // Instagram/LinkedIn are rendered from dedicated props.
                      if (l === "instagram" || l === "linkedin") return false;
                      return true;
                    })
                    .map((p, idx) => (
                      <a
                        key={`${p.label}-${p.url}-${idx}`}
                        href={ensureHref(p.url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex gap-3 items-center font-semibold"
                      >
                        <SocialProfileIcon label={p.label} />
                        {p.label || "Social Media"}
                      </a>
                    ))
                : null}
            </div>
          </div>
        ) : null}

        {/* address */}
        {company || address.length ? (
          <div className="flex items-start gap-3">
            <span className="mt-1">
              <PinIcon />
            </span>
            <div>
              {company ? <p className="font-semibold">{company}</p> : null}
              {address.map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
            </div>
          </div>
        ) : null}

        {onImpressumClick && (
          <button
            onClick={onImpressumClick}
            className="inline-block font-semibold hover:underline mt-6 text-left"
          >
            [IMPRESSUM]
          </button>
        )}
      </div>
    </div>
  );
}
